import { TOptions } from 'i18next';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const useTypedTranslationTemplate = <T extends string>() => {
  const hook = useTranslation();

  const typedT = useCallback(
    (key: T, options?: TOptions) => {
      return hook.t(key, options);
    },
    [hook.t]
  );

  return { ...hook, t: typedT };
};
